export default {"src":"/_next/static/media/apple-login.810ff292.svg","height":25,"width":22,"blurWidth":0,"blurHeight":0};